import { render, staticRenderFns } from "./signUpQuestion.vue?vue&type=template&id=563c032e&"
import script from "./signUpQuestion.vue?vue&type=script&lang=js&"
export * from "./signUpQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('563c032e')) {
      api.createRecord('563c032e', component.options)
    } else {
      api.reload('563c032e', component.options)
    }
    module.hot.accept("./signUpQuestion.vue?vue&type=template&id=563c032e&", function () {
      api.rerender('563c032e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/communityPartyBuilding/activityApply/signUpQuestion.vue"
export default component.exports